// 拿到封装好的网络请求工具包
import request from '../utils/request'
// 校验接口
export const check = () => request({
  url: '/api/users/check',
  headers: { 'Token-Circus': window.localStorage.getItem('Token-Circus') },
})
